import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Zoom from '@mui/material/Zoom';
import Fab from '@mui/material/Fab';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import UpIcon from '@mui/icons-material/KeyboardArrowUp';
import { green } from '@mui/material/colors';
import Box from '@mui/material/Box';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { react: React, "@mui/material/styles": { useTheme }, "@mui/material/AppBar": AppBar, "@mui/material/Tabs": Tabs, "@mui/material/Tab": Tab, "@mui/material/Typography": Typography, "@mui/material/Zoom": Zoom, "@mui/material/Fab": Fab, "@mui/icons-material/Add": AddIcon, "@mui/icons-material/Edit": EditIcon, "@mui/icons-material/KeyboardArrowUp": UpIcon, "@mui/material/colors": { green }, "@mui/material/Box": Box } } });
export default ClientProvider;
